import { Loader } from '@aws-amplify/ui-react';
import React from 'react';
import './Stepper.scss';

interface Step {
  label: string;
  subtitle?: string;
  isActive: boolean;
  isCompleted?: boolean;
  isNextUp?: boolean;
  isLoading?: boolean;
  isLoadingText?: string;
  isLoadingTooltipText?: string;
  isClickable?: boolean;
  isFailed?: boolean;
  onClick?: () => void;
}

interface StepperProps {
  steps: Step[];
  align?: 'center' | 'left';
}

export const Stepper: React.FC<StepperProps> = ({ steps, align = 'center' }) => {
  const handleStepClick = (step: Step) => {
    // Allow click if step is explicitly clickable, or if it's next up and not loading
    if (step.onClick && !step.isLoading && (step.isClickable || step.isNextUp)) {
      step.onClick();
    }
  };

  return (
    <div className={`stepper ${align === 'left' ? 'stepper--left' : ''}`}>
      {steps.map((step, index) => (
        <div
          key={index}
          className={`stepper__step ${step.isActive ? 'stepper__step--active' : ''} ${step.isCompleted ? 'stepper__step--completed' : ''} ${step.isNextUp && !step.isLoading ? 'stepper__step--next-up' : ''} ${step.isClickable && !step.isLoading ? 'stepper__step--clickable' : ''} ${step.isLoading ? 'stepper__step--loading' : ''} ${step.isFailed ? 'stepper__step--failed' : ''}`}
          onClick={() => handleStepClick(step)}
          data-tooltip-id={step.isLoading && step.isLoadingTooltipText ? 'main-tooltip' : undefined}
          data-tooltip-content={step.isLoading && step.isLoadingTooltipText ? step.isLoadingTooltipText : undefined}
        >
          {step.isLoading && (
            <Loader size="small" style={{ marginRight: 5 }} />
          )}
          <div className="stepper__content">
            <span className="stepper__label">
              {step.isLoading && step.isLoadingText ? step.isLoadingText : step.label}
            </span>
            {step.subtitle && <span className="stepper__subtitle">{step.subtitle}</span>}
          </div>
        </div>
      ))}
    </div>
  );
};
